import React, { useState, useEffect } from "react";

const ScrollToTopButton = () => {
  // State to control visibility of the scroll-to-top button
  const [isVisible, setIsVisible] = useState(false);

  // Handle the scroll event to toggle the button visibility
  const handleScroll = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Add scroll event listener on component mount
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-20 right-4 p-4 text-black hover:underline transition duration-300"
        >
          Back to Top
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
